import { Button } from "@mui/material"
import { Secure } from "lib/authorization/secure"
import Iconify from "minimals-template/components/Iconify"
import { useDialog } from "lib/@hooks/useDialog"
import { CreateRegisterDialog } from "routes/regime/assets/create-register-dialog"
import { busyWhile } from "lib/@components/busy/busy-while"
import { createAssetRegister } from "./controller/create-asset-register"
import { navigate } from "lib/routes/navigate"

export function AddAssetRegister() {
    const createDialog = useDialog(<CreateRegisterDialog />)

    return (
        <Secure hide demand="manageAssetRegister">
            <Button
                data-cy="add-asset-register-btn"
                onClick={add}
                variant="contained"
                startIcon={<Iconify icon="mdi:add" />}
            >
                Add Asset Register
            </Button>
        </Secure>
    )

    async function add() {
        const register = await createDialog()
        if (register) {
            const id = await busyWhile(
                async () => createAssetRegister(register.name, register.description),
                "Create Register"
            )
            navigate(`/app/assets/${id}`)
        }
    }
}
